<script lang="ts">
    enum DisplayRecordingStatus {
        INACTIVE,
        COUNTDOWN,
        RECORDING,
        STOPPED,
    }

    import Button from "../materialize/components/Button.svelte";
    import Icon from "../materialize/components/Icon.svelte";
    import ProgressBar from "../materialize/components/ProgressBar.svelte";
    import { createEventDispatcher } from "svelte";
    import { transition_in } from "svelte/internal";
    import Row from "../materialize/grid/Row.svelte";
    import Spinner from "./Spinner.svelte";
import { WebAudioApiWavRecorder } from "./WebAudioApiWavRecorder";

    const dispatch = createEventDispatcher();

    const OPTIONS_AUDIO: string = "audio/ogg, codecs=opus";

    let recording_supported: boolean = true;
    let audio_recorder: WebAudioApiWavRecorder = null;
    let status: DisplayRecordingStatus = DisplayRecordingStatus.INACTIVE;
    let curr_audio_chunks = [];
    function start_audiorecorder() {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            audio_recorder = new WebAudioApiWavRecorder();
        } else {
            recording_supported = false;
        }
    }

    function start_recording() {
            start_audiorecorder();
            count_down_321()
    }
    function stop_recording() {
            setTimeout(async () => {
                audio_recorder.stop();

                const blob = await audio_recorder.wav();
                console.log(blob)
                fire_event_finished_blob(blob);
            }, 500);
        }

    function fire_event_finished_blob(blob_data: Blob) {
        let reader = new FileReader();
        reader.readAsDataURL(blob_data);
        reader.onloadend = function () {
            let base64data = reader.result;
            dispatch("completed", {
                blob: blob_data,
                base64: base64data,
            });
        };
        
    }

    function fire_event_audio_amplitude(amplitude: number) {
        dispatch("audio_measurements", {
            amplitude: amplitude,
        });
    }

    let count_down = 0;
    function count_down_321() {
        status = DisplayRecordingStatus.COUNTDOWN;
        count_down = 3;
        setTimeout(() => {
            count_down = 2;
        }, 1000);
        setTimeout(() => {
            count_down = 1;
        }, 2000);
        setTimeout(() => {
            audio_recorder.start();
        }, 2700);
        setTimeout(() => {
            count_down = 0;
            status = DisplayRecordingStatus.RECORDING;
        }, 3000);
    }
</script>

{#if recording_supported}
    {#if status === DisplayRecordingStatus.INACTIVE}
        <Button
            on:click={start_recording}
            floating={false}
            class_list={["approu-primary", "darken-1"]}
            size="large"
            ><Icon class_list={["large"]} icon="keyboard_voice" /></Button
        >
    {:else if status === DisplayRecordingStatus.COUNTDOWN}
        <h1>{count_down}</h1>
    {:else if status === DisplayRecordingStatus.RECORDING}
        <Button
            on:click={stop_recording}
            floating={true}
            class_list={["red", "pulse"]}
            size="large"><Icon icon="stop" /></Button
        >
    {:else if status === DisplayRecordingStatus.STOPPED}
        <Spinner />
    {/if}
{:else}
    Registrazione audio non supportata o non consentita
{/if}
